<template>
  <div class="satisfy-detail-container" style="width:100%;">
    <!-- 顶部导航栏 -->
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>
    
    <!-- 表格内容 -->
    <div class="table-wrapper">
      <div v-if="dataList.length === 0" style="text-align: center; padding: 50px; color: #999;">
        暂无数据
      </div>
      <table v-else class="native-table" border="1" cellspacing="0" cellpadding="8" style="width:100%; text-align:center;">
        <thead>
        <tr>
          <th>序号</th>
          <th>考核维度</th>
          <th>权重 (%)</th>
          <th>内容</th>
          <th>完成日期</th>
          <th>完成情况</th>
          <th>部门自评</th>
          <th>部门分管领导评分</th>
          <th>董事会评分</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(row, index) in dataList" :key="index">
          <!-- 序号 -->
          <td>{{ index + 1 }}</td>

          <!-- 考核维度 (合并列) -->
          <td v-if="spanArr[index] !== 0" :rowspan="spanArr[index]">
            {{ row.promiseItemLabel }}
          </td>

          <!-- 权重 -->
          <td>{{ row.promiseWeight }}</td>

          <!-- 工作内容 -->
          <td :title="row.promiseContent">{{ row.promiseContent }}</td>

          <!-- 完成日期 -->
          <td>{{ row.finishDateLabel }}</td>

          <!-- 完成情况 -->
          <td>{{ row.finishRemark }}</td>

          <!-- 部门自评 -->
          <td>{{ row.managerGrade }}</td>

          <!-- 部门分管领导评分 -->
          <td>{{ row.chargerGrade }}</td>

          <!-- 董事会评分 -->
          <td>{{ row.meetGrade }}</td>
        </tr>

        <!-- 合计行 -->
        <tr class="total-row" v-if="dataList.length > 0">
          <td class="td-total" colspan="2">合计</td>
          <td class="td-total-score">{{ summaryData.weight }}</td>
          <td class="td-total">-</td>
          <td class="td-total">-</td>
          <td class="td-total">-</td>
          <td class="td-total-score">{{ summaryData.managerGrade }}</td>
          <td class="td-total-score">{{ summaryData.chargerGrade }}</td>
          <td class="td-total-score">{{ summaryData.meetGrade }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "HrPerfPromiseCheckDetail",
  data() {
    return {
      dataList: [],
      spanArr: [],
      summaryData: {
        weight: '',
        managerGrade: '',
        chargerGrade: '',
        meetGrade: ''
      }
    };
  },
  created() {
    const query = this.$route.query;
    if (query.data) {
      try {
        const parsedData = JSON.parse(query.data);
        this.dataList = parsedData || [];
        console.log('接收到的数据:', this.dataList);
        if (this.dataList.length > 0) {
          console.log('第一条数据结构:', this.dataList[0]);
        }
        this.getSpanArr();
        console.log('合并数组:', this.spanArr);
        this.calculateSummary();
      } catch (e) {
        console.error('解析数据失败:', e);
        this.dataList = [];
      }
    } else {
      console.warn('没有接收到数据');
      this.dataList = [];
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    calculateSummary() {
      if (this.dataList.length === 0) return;

      const preciseSum = (values) => {
        const decimalPlaces = values.reduce((max, val) => {
          if (isNaN(val)) return max;
          const parts = val.toString().split('.');
          return parts.length === 2 ? Math.max(max, parts[1].length) : max;
        }, 0);

        const multiplier = Math.pow(10, decimalPlaces);
        const total = values.reduce((prev, curr) => {
          const value = Number(curr);
          return !isNaN(value) ? prev + value * multiplier : prev;
        }, 0);

        return total / multiplier;
      };

      const sumFields = ['promiseWeight', 'chargerGrade', 'meetGrade', 'managerGrade'];
      const fieldMap = {
        promiseWeight: 'weight',
        chargerGrade: 'chargerGrade',
        meetGrade: 'meetGrade',
        managerGrade: 'managerGrade'
      };

      sumFields.forEach(field => {
        const values = this.dataList.map(item => Number(item[field]));
        if (!values.every(value => isNaN(value))) {
          const total = preciseSum(values);
          this.summaryData[fieldMap[field]] = Number(total.toFixed(2));
        } else {
          this.summaryData[fieldMap[field]] = '';
        }
      });
    },
    getSpanArr() {
      let num = 0
      this.spanArr = []

      for (let i = 0; i < this.dataList.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          num = 0
        } else {
          if (this.dataList[i].promiseItem === this.dataList[i - 1].promiseItem) {
            this.spanArr[num] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            num = i
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.satisfy-detail-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f7fa;
  box-sizing: border-box;
}

/* 顶部导航栏样式 */
.header-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  box-sizing: border-box;
}

.back-btn {
  width: 64px !important;
  height: 34px;
  font-size: 13px;
  border: none;
}

.page-title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  flex: 1;
}

.screen-btn {
  width: 64px;
  display: flex;
  justify-content: center;
}

/* 表格容器 */
.table-wrapper {
  width: 100%;
  padding: 58px 12px 12px;
  box-sizing: border-box;
  overflow-x: auto;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.native-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  table-layout: fixed;
}

.native-table th,
.native-table td {
  padding: 10px 8px;
  border: 1px solid #ebeef5;
  text-align: center;
  vertical-align: middle;
  box-sizing: border-box;
  word-wrap: break-word;
  word-break: break-all;
}

.native-table th {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #333;
}

.native-table th:nth-child(1),
.native-table td:nth-child(1) {
  width: 60px;
  min-width: 60px;
}

.native-table th:nth-child(2),
.native-table td:nth-child(2) {
  width: 120px;
  min-width: 120px;
}

.native-table th:nth-child(3),
.native-table td:nth-child(3) {
  width: 70px;
  min-width: 70px;
}

.native-table th:nth-child(4),
.native-table td:nth-child(4) {
  width: 250px;
  min-width: 250px;
}

.native-table th:nth-child(5),
.native-table td:nth-child(5) {
  width: 110px;
  min-width: 110px;
}

.native-table th:nth-child(6),
.native-table td:nth-child(6) {
  width: 180px;
  min-width: 180px;
}

.native-table th:nth-child(7),
.native-table td:nth-child(7) {
  width: 90px;
  min-width: 90px;
}

.native-table th:nth-child(8),
.native-table td:nth-child(8) {
  width: 130px;
  min-width: 130px;
}

.native-table th:nth-child(9),
.native-table td:nth-child(9) {
  width: 90px;
  min-width: 90px;
}

.total-row {
  background-color: #f5f7fa;
}

.td-total {
  padding: 12px 8px;
  border: 1px solid #dcdfe6;
  text-align: center;
  font-size: 14px;
}

.td-total-score {
  padding: 12px 8px;
  border: 1px solid #dcdfe6;
  text-align: center;
  font-size: 14px;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .header-nav {
    height: 48px;
  }
  
  .nav-content {
    padding: 0 10px;
  }
  
  .back-btn {
    width: 60px !important;
    height: 32px;
    font-size: 12px;
  }
  
  .screen-btn {
    width: 60px;
  }
  
  .page-title {
    font-size: 15px;
  }
  
  .table-wrapper {
    padding: 56px 10px 10px;
  }
  
  .native-table {
    font-size: 13px;
  }
  
  .td-name,
  .td-aspect,
  .td-score {
    padding: 8px 10px;
    border: 1px solid #ebeef5;
  }
  
  .td-name {
    width: 140px;
  }
  
  .td-aspect {
    padding-left: 15px;
  }
  
  .native-table tr td:first-child {
    border-left: 1px solid #ebeef5;
  }
}

@media screen and (max-width: 480px) {
  .header-nav {
    height: 46px;
  }
  
  .nav-content {
    padding: 0 8px;
  }
  
  .back-btn {
    width: 56px !important;
    height: 30px;
    font-size: 12px;
  }
  
  .screen-btn {
    width: 56px;
  }
  
  .page-title {
    font-size: 14px;
  }
  
  .table-wrapper {
    padding: 54px 8px 8px;
  }
  
  .native-table {
    font-size: 12px;
  }
  
  .td-name,
  .td-aspect,
  .td-score {
    padding: 6px 8px;
    border: 1px solid #ebeef5;
  }
  
  .td-name {
    width: 120px;
  }
  
  .native-table tr td:first-child {
    border-left: 1px solid #ebeef5;
  }
}
</style>
